const state = () => ({
  allData: [],
  totalData: 0,
  loading: false,
  errors: [],
  flashErrorMessage: '',
  flashError: false,
  totalPage: 0,
  onDownloadResult: false,
});

export default state;
